import { Link } from "react-router-dom";

export type Crumb = { label: string; to?: string };

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex flex-wrap items-center gap-1.5 text-xs md:text-sm text-foreground-500">
        {items.map((item, index) => (
          <li key={`${item.label}-${index}`} className="flex items-center gap-1.5">
            {item.to ? (
              <Link to={item.to} className="hover:text-primary-600 transition-colors whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 whitespace-nowrap" aria-current="page">
                {item.label}
              </span>
            )}
            {index < items.length - 1 ? (
              <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-foreground-300"></i>
            ) : null}
          </li>
        ))}
      </ol>
    </nav>
  );
}